
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
const finance = namespace("finance");

@Component({})
@Table("loadListData")
export default class Customer extends Vue {
  @finance.Action getBillList;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  searchForm = {
    billNo: "",
    billTimeFrom: "",
    billTimeTo: ""
  };
  tmallBillList: any[] = [];
  searchList: any[] = [
    {
      label: t("finance.creation-time"),
      type: "daterange",
      value: "",
      prop: "billTime"
    },
    {
      label: t("finance.statement-account-number"),
      type: "input",
      value: "",
      prop: "billNo"
    }
  ];
  created() {
    this.init();
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "billTime") {
          this.searchForm.billTimeFrom = item.value ? item.value[0] : "";
          this.searchForm.billTimeTo = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleLinkView(row) {
    this.$router.push(`/finance/tmall-bill-view/${row.billNo}`);
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getBillList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.tmallBillList = data.data.list;
      return data;
    });
  }
  handleView(row) {
    this.$router.push(`/setting/customer-view/${row.customerCode}?vehicleCode=${row.vehicleCode}`);
  }
  init() {
    this.loadListData();
  }
}
